// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* global.css */
:root {
    --bright-yellow: #ffcb05;
    --bright-fuschia: cf2c91;
    --hover-fuschia: #cf2c91;
    --bmo-purple: #4700A3; /* BMO brand color */
    --bmo-primary-color-mint: #1FD1BD; /* Primary BMO brand color - mint */    
    --bmo-primary-color-lavender: #A096FF; /* Primary BMO brand color - lavender */
    --bmo-primary-color-mint-light: #BEFAEB; /* Primary BMO brand color - mint light */    
    --bmo-primary-color-lavender-light: #E1DCFF; /* Primary BMO brand color - lavender light */
    --bmo-primary-color-mint-dark: #009392; /* Primary BMO brand color - mint dark */    
    --bmo-primary-color-lavender-dark: #7D78E8; /* Primary BMO brand color - lavender dark */
    --bmo-primary-color-lavender-darker: #5C55B0; /* Not supported from BMO palette instead added for repeating gradients by Mikael Johansson - lavender darker */    
}

/*
 * Feature-scoped global overrides for ProofOfDeliveryLayout.
 * Add descendant selectors and third-party component overrides here when they
 * should apply everywhere inside the PoD feature, but nowhere else in the app.
 */
.proof-of-delivery-global-overrides a {
    color: var(--bmo-primary-color-mint);
}

.proof-of-delivery-global-overrides a:visited {
    color: var(--bmo-primary-color-mint);
}

.proof-of-delivery-global-overrides a:hover,
.proof-of-delivery-global-overrides a:focus {
    color: var(--bmo-primary-color-mint-dark);
}

.react-datepicker {
    font-size: 1em;
}

.react-datepicker__header {
    padding-top: 0.8em;
}

.react-datepicker__month {
    margin: 0.4em 1em;
}

.react-datepicker__day-name, .react-datepicker__day {
    width: 1.9em;
    line-height: 1.9em;
    margin: 0.166em;
}

.react-datepicker__current-month {
    font-size: 1em;
}

.react-datepicker__navigation {
    top: 1em;
    line-height: 1.7em;
    border: 0.45em solid transparent;
}

.react-datepicker__navigation--previous {
    border-right-color: #ccc;
    left: 1em;
}

.react-datepicker__navigation--next {
    border-left-color: #ccc;
    right: 1em;
}`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Pod.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,qBAAqB,EAAE,oBAAoB;IAC3C,iCAAiC,EAAE,mCAAmC;IACtE,qCAAqC,EAAE,uCAAuC;IAC9E,uCAAuC,EAAE,yCAAyC;IAClF,2CAA2C,EAAE,6CAA6C;IAC1F,sCAAsC,EAAE,wCAAwC;IAChF,0CAA0C,EAAE,4CAA4C;IACxF,4CAA4C,EAAE,+GAA+G;AACjK;;AAEA;;;;EAIE;AACF;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,UAAU;AACd","sourcesContent":["/* global.css */\n:root {\n    --bright-yellow: #ffcb05;\n    --bright-fuschia: cf2c91;\n    --hover-fuschia: #cf2c91;\n    --bmo-purple: #4700A3; /* BMO brand color */\n    --bmo-primary-color-mint: #1FD1BD; /* Primary BMO brand color - mint */    \n    --bmo-primary-color-lavender: #A096FF; /* Primary BMO brand color - lavender */\n    --bmo-primary-color-mint-light: #BEFAEB; /* Primary BMO brand color - mint light */    \n    --bmo-primary-color-lavender-light: #E1DCFF; /* Primary BMO brand color - lavender light */\n    --bmo-primary-color-mint-dark: #009392; /* Primary BMO brand color - mint dark */    \n    --bmo-primary-color-lavender-dark: #7D78E8; /* Primary BMO brand color - lavender dark */\n    --bmo-primary-color-lavender-darker: #5C55B0; /* Not supported from BMO palette instead added for repeating gradients by Mikael Johansson - lavender darker */    \n}\n\n/*\n * Feature-scoped global overrides for ProofOfDeliveryLayout.\n * Add descendant selectors and third-party component overrides here when they\n * should apply everywhere inside the PoD feature, but nowhere else in the app.\n */\n.proof-of-delivery-global-overrides a {\n    color: var(--bmo-primary-color-mint);\n}\n\n.proof-of-delivery-global-overrides a:visited {\n    color: var(--bmo-primary-color-mint);\n}\n\n.proof-of-delivery-global-overrides a:hover,\n.proof-of-delivery-global-overrides a:focus {\n    color: var(--bmo-primary-color-mint-dark);\n}\n\n.react-datepicker {\n    font-size: 1em;\n}\n\n.react-datepicker__header {\n    padding-top: 0.8em;\n}\n\n.react-datepicker__month {\n    margin: 0.4em 1em;\n}\n\n.react-datepicker__day-name, .react-datepicker__day {\n    width: 1.9em;\n    line-height: 1.9em;\n    margin: 0.166em;\n}\n\n.react-datepicker__current-month {\n    font-size: 1em;\n}\n\n.react-datepicker__navigation {\n    top: 1em;\n    line-height: 1.7em;\n    border: 0.45em solid transparent;\n}\n\n.react-datepicker__navigation--previous {\n    border-right-color: #ccc;\n    left: 1em;\n}\n\n.react-datepicker__navigation--next {\n    border-left-color: #ccc;\n    right: 1em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
